import { InjectionToken, FactoryProvider } from '@angular/core';

export interface DefaultFieldsOptions {
  first_character: boolean;
  size_view: boolean;
  size_add: boolean;
  note_view: boolean;
  note_add: boolean;
  actual_wait: boolean;
  estimated_wait: boolean;
  arrivalTime: boolean;
  quotedTime: boolean;
  phone: boolean;
  phone_add: boolean;
  noteOptions: string[];
  columns: boolean;
  position: boolean;
  striped: boolean;
  upcoming: boolean;
  showService: boolean;
  showResource: boolean;
  // DockMagic options
  showDeliveryId: boolean;
  showDeliveryIdCheckIn: boolean;
  showTruck: boolean;
  showTruckCheckIn: boolean;
  showCarrier: boolean;
  showCarrierCheckIn: boolean;
  showServicesCheckIn: boolean;
  showResourcesCheckIn: boolean;
}

export const DEFAULT_FIELDS_OPTIONS = new InjectionToken<DefaultFieldsOptions>(
  'Default Fields Options'
);

export const defaultFieldsOptionsProvider: FactoryProvider = {
  provide: DEFAULT_FIELDS_OPTIONS,
  useFactory: (): DefaultFieldsOptions => {
    return {
      first_character: false,
      size_view: false,
      size_add: true,
      note_view: false,
      note_add: true,
      actual_wait: true,
      estimated_wait: true,
      phone: true,
      phone_add: true,
      showService: false,
      showResource: false,
      showDeliveryId: false,
      showDeliveryIdCheckIn: false,
      showTruck: false,
      showTruckCheckIn: false,
      showCarrier: false,
      showCarrierCheckIn: false,
      noteOptions: [],
      columns: true,
      position: false,
      striped: true,
      upcoming: false,
      arrivalTime: false,
      quotedTime: false,
      showServicesCheckIn: false,
      showResourcesCheckIn: false
    };
  },
};
